export function tryParseJson(value: string | null): any {
    if (value === null || value === 'undefined') {
        return value;
    }

    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}
